import type { GeocodeResult } from '../domain/types';
import { el, spinner } from './dom';

export interface LocationViewProps {
  status: 'idle' | 'locating' | 'searching';
  error: string | null;
  results: GeocodeResult[];
  onUseGps: () => void;
  onSearch: (query: string) => void;
  onPick: (result: GeocodeResult) => void;
}

export function locationView(props: LocationViewProps): HTMLElement {
  if (props.status === 'locating') {
    return el(
      'div',
      { class: 'grow' },
      spinner(),
      el('p', { class: 'muted centered' }, 'Finding you…'),
    );
  }

  const input = el('input', {
    id: 'place',
    type: 'text',
    placeholder: 'Neighborhood, city, or address',
    autocomplete: 'off',
  });

  const form = el(
    'form',
    {
      class: 'stack',
      onsubmit: (event: Event) => {
        event.preventDefault();
        const query = input.value.trim();
        if (query.length >= 2) props.onSearch(query);
      },
    },
    el('div', { class: 'field' }, el('label', { for: 'place' }, 'Or type where you are'), input),
    el(
      'button',
      {
        class: 'btn',
        type: 'submit',
        disabled: props.status === 'searching',
      },
      props.status === 'searching' ? 'Looking up…' : 'Use this place',
    ),
  );

  const matches =
    props.results.length > 0 &&
    el(
      'div',
      { class: 'stack' },
      ...props.results.map((result) =>
        el(
          'button',
          {
            class: 'card',
            type: 'button',
            onclick: () => props.onPick(result),
          },
          el('p', { class: 'card__name' }, result.label.split(',')[0] ?? result.label),
          el('p', { class: 'card__address' }, result.label),
        ),
      ),
    );

  return el(
    'div',
    { class: 'grow' },
    el('h2', { class: 'question__prompt' }, 'Where are you?'),
    el(
      'button',
      { class: 'btn btn--primary', type: 'button', onclick: props.onUseGps },
      'Use my location',
    ),
    props.error && el('p', { class: 'error' }, props.error),
    form,
    matches,
  );
}
